import { useIsSuperAdmin } from '@savgroup-front-common/core/src/hooks';

const useHasTenantThemePermission = (): boolean => {
  return useIsSuperAdmin();
};

export default useHasTenantThemePermission;
